import { useEffect, useState } from 'react';
import { AxiosResponse } from 'axios';
import { useQuery } from 'react-query';
import { getDrawsService } from 'pages/Raffle/services/raffle';
import { TBaseResponse } from 'types/services/common';
import { TRaffleDrawItem } from '../../types/common.types';

type GetDraws = {
  isQueryingGetDraws: boolean;
  getDrawItems: () => void;
  hasErrorQueryingDraws: boolean;
  drawItems: TRaffleDrawItem[] | undefined;
  stopRefetchInterval: () => void;
  startRefetchInterval: () => void;
  errorMessage: string;
  errorCode: number | undefined;
};

function useGetDraws(): GetDraws {
  const [refetchIntervally, setRefetchIntervally] = useState(false);
  const REFETCH_INTERVAL_SECONDS = 30;
  const [hasError, setHasError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [errorCode, setErrorCode] = useState<number | undefined>(undefined);

  const sortingStr = 'BY_TICKETS_SOLD_PER_MINUTE';

  const {
    isLoading: isQueryingGetDraws,
    refetch: getDraws,
    data: draws,
    isError,
  } = useQuery('getDraws', () => getDrawsService(sortingStr), {
    onSuccess: (data) => checkErrorOnsuccess(data),
    enabled: refetchIntervally,
    suspense: false,
    refetchInterval: REFETCH_INTERVAL_SECONDS * 1000,
    refetchIntervalInBackground: true,
    refetchOnWindowFocus: false,
  });

  function checkErrorOnsuccess(data: AxiosResponse<TBaseResponse<unknown>>) {
    if ((data.data.error || data.data.errorCode) && !drawItems) {
      setHasError(true);
      setDrawItems(undefined);
      setErrorCode(data.data.errorCode);
      setErrorMessage(data.data?.errorMessage ?? '');
    }
  }

  useEffect(() => {
    if (draws?.data?.success) {
      setHasError(false);
      setDrawItems(draws.data.result.draws);
    }
  }, [draws]);

  const [drawItems, setDrawItems] = useState<TRaffleDrawItem[] | undefined>(
    undefined
  );

  function getDrawItems() {
    startRefetchInterval();
    getDraws();
  }

  function startRefetchInterval() {
    setRefetchIntervally(true);
  }

  function stopRefetchInterval() {
    setRefetchIntervally(false);
  }

  return {
    isQueryingGetDraws,
    getDrawItems,
    hasErrorQueryingDraws: hasError || isError,
    drawItems,
    startRefetchInterval,
    stopRefetchInterval,
    errorMessage,
    errorCode,
  };
}

export default useGetDraws;
